import React from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, stopSubmit } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";
import Wysiwyg from "../../system/fields/Wysiwyg";

import { getBoardTypes, getFacilities, getRoomTypes } from '../../store/overview';
import CreatableSelect from "../../system/fields/CreatableSelect";

import * as Validations from '../../system/utils/Validation';

class EditForm extends React.Component {
  
  // componentDidMount() {
  //   this.props.dispatch(getBoardTypes());
  //   this.props.dispatch(getFacilities());
  //   this.props.dispatch(getRoomTypes());
  // }
  
  render() {
    const { props } = this;
    const { fields } = props;
    const { handleSubmit } = props;
    return (
      <section className="edit-form">
        <Form onSubmit={handleSubmit}>
          <section className="form-section">
            <div className="row">

              <FormGroup className="col-12 col-sm-6">
                <Label>Search Tag Name</Label>
                <Field
                  name="value"
                  component={TextInput}
                  placeholder="Search Tag Name"
                  
                  type="text"
                  autoFocus={true}
                />
              </FormGroup>

         

            </div>

  
          </section>
        </Form>

        {props.submitFailed && (
          <div className="error-container">
            <Alert color="danger">
              <strong>There are errors in your form.</strong>
              <br />Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: "SearchTagForm"
})(EditForm);

const mapStateToProps = state => {
  console.log(state, 'hello')
  return {
    searchTags: state.form.SearchTagForm
  }
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/SearchTags/Form.jsx